import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Report from "../Report";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { dateReportFormatter, dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import SubGroup from "../SubGroup";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";

function UserRights() {
  const [user, setUser] = useState("");
  const onUserChange = useCallback((u) => setUser(u), []);
  const { values: users } = useDataFormatterHook({
    addEmpty: true,
    value: "loginName",
    text: "loginName",
    path: `/User/GetUsers`,
  });

  const [right, setRight] = useState("");
  const onRightChange = useCallback((r) => setRight(r), []);
  const { values: rights } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/User/GetRights`,
  });

  const [form, setForm] = useState("");
  const onFormChange = useCallback((f) => setForm(f), []);
  const { values: forms } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/User/GetForms`,
  });

  const [profile, setProfile] = useState("");
  const onProfileChanged = useCallback((p) => setProfile(p), []);
  const { values: profiles } = useDataFormatterHook({
    addEmpty: true,
    value: "profileName",
    text: "profileName",
    path: `/User/UserProfile_GetList`,
  });

  const [status, setStatus] = useState(0);
  const onStatusChange = useCallback(
    (event) => setStatus(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <InputSelect
          variant="outlined"
          size="small"
          label="User"
          name="name"
          data={users}
          placeholder="DataFormatter"
          setSelectValue={onUserChange}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Right"
          name="name"
          data={rights}
          placeholder="DataFormatter"
          setSelectValue={onRightChange}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Screen"
          name="name"
          data={forms}
          placeholder="DataFormatter"
          setSelectValue={onFormChange}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Profile"
          name="name"
          data={profiles}
          placeholder="DataFormatter"
          setSelectValue={onProfileChanged}
          startValue={""}
        />
        <div>
          <SubGroup title="Status">
            <FormControl component="fieldset">
              <RadioGroup label value={status} onChange={onStatusChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Enabled"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Disabled"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Users Rights Report"
        getUrl={() => "/Reports/Report_Users_Right_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          User: user,
          Right: right,
          Form: form,
          Profile: profile,
          Status: status,
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="loginName">
          User
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="category">
          Category
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="forms">
          Autorized Screen
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="rights">
          Right
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="system">
          System
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="placedDate"
          dataFormat={dateTimeReportFormatter}
        >
          Placed Date
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default UserRights;
